import type { Drill } from '@acepoker/contract'

export function stringifyGamingConfiguration(
  gamingConfiguration: Drill['gaming_configuration'],
  maxPlayers: number
): string {
  return `${gamingConfiguration.game}, ${maxPlayers}-max, ${gamingConfiguration.blinds.length}-blinds ${gamingConfiguration.antes ? `+ Ante` : ''}`
}
